import React from 'react'

export default function Footer() {
  return (
    <div className='footer'>
      <span>&copy;Mussafara Riaz -2022 | all rights reserved</span>
      <div className='footer-icons'>
      
       <span><a  href="https://github.com/MUSSAFARA-RIAZ"><i class="fa-brands fa-github"></i></a></span>
       <span><a  href="https://www.facebook.com/mussafira.ahmed"><i class="fa-brands fa-facebook-f"></i></a></span>
       <span><a  href="https://www.linkedin.com/in/mussafara-riaz-a38012213/"><i class="fa-brands fa-linkedin"></i></a></span>
       </div>
    </div>
  )
}